@charset "UTF-8";

/* src/app/pages/cash-flow/cash-flow.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: flex;
  flex-direction: column;
  background: var(--cds-background-accent);
  padding: 32px 24px;
}
:host ::ng-deep bfm-cash-flow-filter-pills {
}
:host ::ng-deep bfm-cash-flow-filter-pills button.cds-button.s-plain {
  --height: 40px;
  border: 1px solid var(--cds-primary-500);
  padding: 18px 16px;
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filter-pills button.cds-button.s-plain:not(:disabled):hover {
  color: var(--cds-background-main);
  border-color: var(--cds-primary-500);
  background: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filter-pills button.cds-button.s-plain:not(:disabled):hover i {
  color: var(--cds-background-main);
}
:host ::ng-deep bfm-cash-flow-filter-pills button.cds-button.s-plain i {
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filter-pills .applied-filters.show-time h1 {
  color: var(--cds-primary-500) !important;
  font-weight: 700 !important;
}
:host ::ng-deep bfm-cash-flow-filter-pills .applied-filters.show-time h6 {
  font-size: 12px;
}
:host ::ng-deep bfm-cash-flow-filter-pills .applied-filters {
  margin: 30px 0 0;
  width: 100%;
}
:host ::ng-deep bfm-cash-flow-filter-pills header,
:host ::ng-deep bfm-cash-flow-filter-pills .applied-filters.show-time,
:host ::ng-deep bfm-cash-flow-filter-pills .applied-filters.show-time .applied-filters-title {
  width: 100%;
}
:host ::ng-deep bfm-cash-flow-filter-pills header {
  padding-bottom: 0px;
}
:host ::ng-deep bfm-cash-flow-filter-pills header cds-tab [type=radio]:checked ~ label {
  font-weight: 600 !important;
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep bfm-cash-flow-filters {
}
:host ::ng-deep bfm-cash-flow-filters button.cds-button.s-plain {
  --height: 40px;
  border: 1px solid var(--cds-primary-500);
  padding: 18px 16px;
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filters button.cds-button.s-plain:not(:disabled):hover {
  color: var(--cds-background-main);
  border-color: var(--cds-primary-500);
  background: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filters button.cds-button.s-plain:not(:disabled):hover i {
  color: var(--cds-background-main);
}
:host ::ng-deep bfm-cash-flow-filters button.cds-button.s-plain i {
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-cash-flow-filters .applied-filters.show-time h1 {
  color: var(--cds-primary-500) !important;
  font-weight: 700 !important;
}
:host ::ng-deep bfm-cash-flow-filters .applied-filters.show-time h6 {
  font-size: 12px;
}
:host ::ng-deep bfm-cash-flow-filters .applied-filters {
  margin: 30px 0 0;
  width: 100%;
}
:host ::ng-deep bfm-cash-flow-filters header,
:host ::ng-deep bfm-cash-flow-filters .applied-filters.show-time,
:host ::ng-deep bfm-cash-flow-filters .applied-filters.show-time .applied-filters-title {
  width: 100%;
}
:host ::ng-deep bfm-cash-flow-filters header {
  padding-bottom: 0px;
}
:host ::ng-deep bfm-cash-flow-filters header cds-tab [type=radio]:checked ~ label {
  font-weight: 600 !important;
  color: var(--cds-primary-500) !important;
}
:host ::ng-deep bfm-paginated-cash-flow {
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row {
  grid-template-rows: 80px;
  height: 80px;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .status {
  justify-content: center;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row i.cds-icon-search {
  color: var(--cds-primary-500);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .value.c-text-medium {
  --color: var(--cds-primary-500);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .cds-icon-filled-check {
  color: var(--cds-revenue);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .cds-icon-filled-clock {
  color: var(--cds-text-light);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .cds-icon-filled-alert-triangle {
  color: var(--cds-danger-400);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .name {
  line-height: 1.35;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row .bank_id .bank-details p {
  line-height: 1.35;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list bfm-value-accordion header {
  background: transparent;
  padding: 24px 0px;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .financial-record-accordion header,
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .financial-record-accordion .account-last-value {
  flex-direction: column;
  align-items: flex-end;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .financial-record-accordion header h4,
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .financial-record-accordion .account-last-value h4 {
  --color: var(--cds-text-primary);
  font-weight: 700;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .financial-record-accordion .group-header {
  margin-top: 32px;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list ul.striped .financial-record-header {
  background-color: var(--cds-foreground-20);
  height: 80px;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list ul.striped .financial-record-header h5 {
  font-weight: 600;
  color: var(--cds-text-strong);
  font-size: 16px;
  line-height: 1.25;
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list ul.striped bfm-list-item:nth-child(even) {
  background: var(--cds-foreground-20);
}
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list .striped-row,
:host ::ng-deep bfm-paginated-cash-flow .financial-record-list ul.striped .financial-record-header {
  gap: 12px;
}
.container-cash-flow {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.container-cash-flow .financial-records-container {
  display: flex;
  flex-direction: column;
  background-color: var(--cds-background-main);
  padding: 20px;
  gap: 0px;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  width: 100%;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper bfm-cash-flow-filters {
  display: contents;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters {
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters .applied-filters,
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters bfm-cash-flow-filter-pills {
  display: contents;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters > header,
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters .applied-filters-title,
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters > .period-report,
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters > bfm-balance-alert {
  flex: 0 0 100%;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters .applied-filters-title {
  margin: 20px 0 18px;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters bfm-download-button {
  order: 1;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters > .period-report,
.container-cash-flow .financial-records-container .filters-actions-wrapper ::ng-deep bfm-cash-flow-filters > bfm-balance-alert {
  order: 2;
}
.container-cash-flow .financial-records-container .filters-actions-wrapper button {
  --height: 38px;
  flex: 0 0 auto;
  padding: 0 16px;
}
/*# sourceMappingURL=cash-flow.component.css.map */
